import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Tooltip } from '@mui/material';
import { useTranslate } from 'react-admin';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const ExpandAllButton = () => {
    const translate = useTranslate();
    const [expanded, setExpanded] = React.useState(false);

    const handleClick = () => {
        setExpanded(!expanded);
        // TODO: Implement expand all functionality
    };

    return (
        <Tooltip title={translate(expanded ? 'ra.action.close_all' : 'ra.action.expand_all')}>
            <IconButton aria-label={translate(expanded ? 'ra.action.close_all' : 'ra.action.expand_all')} onClick={handleClick} size='small'>
                {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </IconButton>
        </Tooltip>
    );
};

ExpandAllButton.propTypes = {
    resource: PropTypes.string,
    ids: PropTypes.arrayOf(PropTypes.any),
};

export default ExpandAllButton;
